import ComponentModule from "@eisinc/Overrides/Components/ProductDescription";

export * from "@eisinc/Overrides/Components/ProductDescription";

export default ComponentModule;
